import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type IntegrationProblemType as SchemaIntegrationProblemType } from '../schemas/IntegrationProblemType';
import { type IntegrationType as SchemaIntegrationType } from '../schemas/IntegrationType';
import { type Problem as SchemaProblem } from '../schemas/Problem';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @description Starts an asynchronous search without changing the active mapping or creating product links.
A concurrent search for the same source is rejected. Derived sources use their base source.

 * @tags Integrations
 */
export const StartMappingDiscoveryContentType = '' as const;
export type StartMappingDiscoveryRequest = void;
export type StartMappingDiscoveryResponses = LinkCommonErrorResponses & {
    /**
     * @description Mapping discovery accepted; status is running before the response, previous result is retained
     */
    '200': {};
    /**
     * @description Invalid input or validation error
     */
    '400': {
        'application/json': SchemaProblem & {
            type: SchemaIntegrationProblemType;
        };
    };
    /**
     * @description Mapping discovery is already running for this source
     */
    '409': {
        'application/json': SchemaProblem;
    };
};
export type StartMappingDiscoveryResponseSuccess = undefined;
export type StartMappingDiscoverySearchParams = undefined;
export type StartMappingDiscoveryPathParameters = {
    integration_type: SchemaIntegrationType;
};
export const StartMappingDiscoveryUrl = '/integrations/mapping_discovery/{integration_type}/start' as const;
export const StartMappingDiscoveryMethod = 'POST' as const;
export const getStartMappingDiscoveryUrl = (params: StartMappingDiscoveryPathParameters) =>
    StartMappingDiscoveryUrl.replace(/\{(\w+)\}/g, (_match, param: keyof StartMappingDiscoveryPathParameters) =>
        String(params[param])
    );
